export interface SectionPosition {
  id: string;
  /** Distance from the viewport top to the section's top edge, in px. */
  top: number;
  /** How far below the viewport top the section may sit and still count as
   *  reached (its `scroll-margin-top`, so scrolling to it lands "active"). */
  offset: number;
}

/**
 * Picks the section the reader is currently in: the last one, in page order,
 * whose top has scrolled up to (or past) its offset. Before any section is
 * reached the first one is active; once the page is scrolled to the bottom
 * the last one is, even if it is too short to ever reach the offset.
 */
export const pickActiveSection = (
  sections: readonly SectionPosition[],
  atBottom: boolean,
): string | undefined => {
  if (sections.length === 0) {
    return undefined;
  }
  if (atBottom) {
    return sections[sections.length - 1].id;
  }

  // Smooth scrolling can settle a fraction of a pixel short of the target.
  return sections.reduce(
    (active, section) =>
      section.top <= section.offset + 1 ? section.id : active,
    sections[0].id,
  );
};
